import { cast, destroy, flow, types, } from 'mobx-state-tree';
import { Storage } from 'aws-amplify';
const FileModel = types
    .model('File', {
    id: types.identifier, // will be the path in s3
    name: types.string,
    size: types.integer,
    eTag: types.string,
    lastModified: types.string,
})
    .actions((self) => ({
    // This is an auto-generated example action.
    log() {
        console.log(JSON.stringify(self));
    },
}));
export const FileStateEnum = types.enumeration('State', ['pending', 'done', 'error']);
async function getListOfFiles() {
    const results = await Storage.list('', { level: 'private' });
    console.log('results', results);
    return results.map((file) => FileModel.create({
        id: file.key,
        name: file.key,
        size: file.size,
        eTag: file.eTag,
        lastModified: file.lastModified.toString(),
    }));
}
export const S3FileModel = types
    .model('S3FileModel', {
    fileState: FileStateEnum,
    files: types.array(FileModel),
})
    .actions((self) => ({
    fetchFiles: flow(function* fetchFiles() {
        console.log('Fetching files');
        self.files = cast([]);
        self.fileState = cast('pending');
        try {
            // const data = yield
            // map data to video objects and return
            self.fileState = 'done';
            self.files = yield getListOfFiles();
        }
        catch (error) {
            console.log('Error fetching files', error);
            // airbrake.notify(error);
            self.fileState = 'error';
        }
    }),
    addFile(s3file) {
        const file = FileModel.create({
            id: s3file.key,
            name: s3file.key,
            size: s3file.size,
            eTag: s3file.eTag,
            lastModified: s3file.lastModified.toString(),
        });
        self.files.push(file);
    },
    removeFile: flow(function* removeFile(file) {
        self.fileState = 'pending';
        try {
            yield Storage.remove(file.id, {
                level: 'private',
            });
            destroy(file);
            self.fileState = 'done';
        }
        catch (error) {
            console.log('Error deleting file', error);
            // airbrake.notify(error);
            self.fileState = 'error';
        }
    }),
}));
S3FileModel.create({
    fileState: 'done',
});
//# sourceMappingURL=S3FileModel.js.map